import Alerts from "./Alerts";

function Results(props) {

    const {results, text} = props

    return (
        <>

            {results === 'EX' && <Alerts severity={'error'}
                                         body={text}/>}
            {results === 'OK' && <Alerts severity={'success'}
                                         body={text}/>}
            {results === 'INF' && <Alerts severity={'success'}
                                         body={text}/>}
        </>
    )

}

export default Results